import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

export const Footer = () => (
  <footer className="overflow-hidden border-t border-borderline bg-ivory" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6 pt-20 md:px-10">
      <div className="flex flex-wrap items-start justify-between gap-10 pb-20">
        <Reveal>
          <p className="font-serif text-2xl italic text-ink">kanakleaf</p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-smoke">
            Gold that grows. Botanical fine jewellery in sterling silver and warm gold finishes.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <nav className="flex gap-10 text-xs uppercase tracking-[0.25em]" data-testid="footer-links">
            <Link to="/" data-testid="footer-home-link" className="text-smoke transition-colors duration-300 hover:text-golddark">
              Home
            </Link>
            <Link to="/catalogue" data-testid="footer-catalogue-link" className="text-smoke transition-colors duration-300 hover:text-golddark">
              Catalogue
            </Link>
          </nav>
        </Reveal>
      </div>
    </div>
    <Reveal y={60}>
      <h2
        className="select-none whitespace-nowrap text-center font-serif text-[13.5vw] leading-[0.85] tracking-tight text-ink/90"
        data-testid="footer-wordmark"
        aria-hidden="true"
      >
        kanak<span className="italic text-golddark">leaf</span>
      </h2>
    </Reveal>
    <div className="border-t border-borderline">
      <p className="mx-auto max-w-7xl px-6 py-6 text-[11px] uppercase tracking-[0.25em] text-smoke md:px-10">
        © 2026 kanakleaf · Crafted with intention
      </p>
    </div>
  </footer>
);
